import React from 'react';
import { renderMarkdownContent } from '../../utils/markdownRenderer';
import './messageRenderer.css';

interface MessageRendererProps {
  content: string;
  messageId: string;
  className?: string;
  citationSources?: any[];
  onCitationClick?: (index: number) => void;
}

/**
 * MessageRenderer - Exact same rendering logic as ChatHistory.tsx
 * Renders markdown content with citation support using the working approach
 */
const MessageRenderer: React.FC<MessageRendererProps> = ({
  content,
  messageId,
  className = '',
  citationSources = [],
  onCitationClick
}) => {
  return (
    <div
      className={`response-content-direct markdown-content ${className}`}
      data-message-id={messageId}
      dangerouslySetInnerHTML={{
        __html: renderMarkdownContent(content || '', {
          citationSources,
          onCitationClick
        })
      }}
    />
  );
};

export default MessageRenderer;